// extracted by mini-css-extract-plugin
export var colorSquare = "_ny-0";
export var container = "_ny-h";
export var danger = "_ny-5";
export var lightPink = "_ny-8";
export var neutralBlue = "_ny-7";
export var neutralYellow = "_ny-6";
export var normal = "_ny-1";
export var primary = "_ny-2";
export var primaryLight = "_ny-3";
export var selected = "_ny-i";
export var solidBlack = "_ny-g";
export var solidGreen = "_ny-b";
export var solidLightBlue = "_ny-d";
export var solidNavy = "_ny-c";
export var solidOrange = "_ny-f";
export var solidPink = "_ny-e";
export var solidRed = "_ny-9";
export var solidYellow = "_ny-a";
export var success = "_ny-4";